import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  GetSalesRegister(payload) {
    return Api().post(`/api/reports/salesRegisterReport`, payload);
  },
  ItemSalesRegister(payload) {
    return Api().post(`/api/reports/itemSalesRegisterReport`, payload);
  },
  PollForSalesRegisterExcel(payload) {
    return Api().post(`/api/reports/check-sales-register-excel`, payload);
  },
  GetGcamNewExcel(payload) {
    return Api().post(`api/reports/gcamReport`, payload);
  },
  GetReportBuilderFilter(payload) {
    return Api().get(`api/reports/report-builder-v2-filter`, payload);
  },
  GetReportBuilderData(payload) {
    return Api().post(`api/reports/report-builder-v2`, payload);
  }
};



// WEBPACK FOOTER //
// ./src/services/NewReportService.js